import { createStyles } from 'antd-style';
export var useStyles = createStyles(function (_ref) {
  var token = _ref.token;
  return {
    container: {
      height: 40,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      borderBottom: "1px solid rgba(5, 5, 5, 0.06)",
      '& > .ant-tabs': {
        width: '100%',
        '& > .ant-tabs-nav': {
          margin: '0 !important',
          '&:before': {
            display: 'none'
          },
          '& .ant-tabs-nav-list': {
            alignItems: 'center'
          },
          '& .ant-tabs-tab': {
            height: 32,
            marginLeft: '8px !important'
          },
          '& .ant-tabs-tab-active': {
            borderBlockColor: "".concat(token.colorBorder, " !important")
          }
        }
      }
    }
  };
});